var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "40", height: "40", viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("rect", { x: ".5", y: ".5", width: "39", height: "39", rx: "19.5", fill: "#fff" }),
    React.createElement("path", { d: "M16 12H14L11 22V24.5M11 24.5C11 26.433 12.567 28 14.5 28C16.433 28 18 26.433 18 24.5C18 22.567 16.433 21 14.5 21C12.567 21 11 22.567 11 24.5ZM24 12H26L29 22V24.5M29 24.5C29 26.433 27.433 28 25.5 28C23.567 28 22 26.433 22 24.5C22 22.567 23.567 21 25.5 21C27.433 21 29 22.567 29 24.5ZM18 24H22", stroke: "#003A42", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("rect", { x: ".5", y: ".5", width: "39", height: "39", rx: "19.5", stroke: "#ECECEC" })
  );
});